import AppLoading from 'components/common/AppLoading'
import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { getUserAuthenticatedAction } from 'store/actions/user/auth.actions'

const AuthGuard = () => {
  const dispatch = useDispatch()
  const getUserAuthenticated = useCallback(() => dispatch(getUserAuthenticatedAction()), [dispatch])
  const { loading, user, token } = useSelector(state => state.user.auth)

  useEffect(() => {
    if (!!token && !user) {
      getUserAuthenticated()
    }
  }, [token, getUserAuthenticated, user])

  // Espera a que se obtenga el usuario autenticado si se ha refrescado la página
  if (loading || (!!token && !user)) return <AppLoading />

  // Si existe el usuario continua, sino lo redirige al login 
  return user?.id
    ? <Outlet />
    : <Navigate to="/login" replace />
}

export default AuthGuard